import { reactive } from 'vue';

export const notificationBus = reactive({
  notifications: [],
  add(message, type = 'success', duration = 3000) {
    const id = Date.now() + Math.random();
    this.notifications.push({ id, message, type });
    setTimeout(() => this.remove(id), duration);
  },
  remove(id) {
    const index = this.notifications.findIndex(n => n.id === id);
    if (index !== -1) {
      this.notifications.splice(index, 1);
    }
  }
});